import qs from 'query-string';
import moment from 'moment';
import _ from 'lodash';
import api, { dedeshify } from '../utils/api';

const applicationJsonType = {
  headers: {
    'Content-Type': 'application/json',
  },
};

const whereQuery = (filter, rest = {}) => qs.stringify({
  ...rest,
  where: JSON.stringify(filter),
});

const returnItems = resp => resp.json()
  .then(({ _items }) => _items);

export const getUserSubscriptions = userId =>
  api(`/ticket/channel_subscription?${whereQuery({ user_id: dedeshify(userId) })}`)
    .then(returnItems);

export const getAffiliateChannels = affiliateId =>
  api(`/ticket/channel?${whereQuery({ affiliate_id: dedeshify(affiliateId) })}`)
    .then(returnItems);

export const getUserChannels = (userId, affiliateId) =>
  Promise.all([
    getUserSubscriptions(userId),
    getAffiliateChannels(affiliateId),
  ]).then(([subscriptions, channels]) => {
    const channelsById = _.keyBy(channels, '_id');
    return _.map(subscriptions, 'channel_id')
      .filter(id => _.has(channelsById, id))
      .reduce((all, id) => [...all, channelsById[id]], []);
  });

export const getChannelByName = (affiliateId, channelName) =>
  api(`/ticket/channel?${whereQuery({ affiliate_id: dedeshify(affiliateId), name: channelName })}`)
    .then(returnItems)
    .then(_.first);

const statusMap = {
  new: ['new'],
  resolved: ['resolved'],
  closed: ['closed'],
  closed_canceled: ['closed', 'canceled'],
  open: ['new', 'acknowledged', 'assigned'],
  open_resolved: ['new', 'acknowledged', 'assigned', 'resolved'],
};

export const getRequestsNextPage = url =>
  api(`/ticket/${url}`).then(resp => resp.json());

export const getRequestsByFilter = (affiliateId, options) => {
  const opts = {
    status: 'all',
    max_results: 100,
    sort: 'delivery',
    assignedTo: null,
    channels: [],
    onlyMyChannels: true,
    ...options,
  };

  const inStatus = status => ({
    status: { $in: statusMap[status] },
  });

  const updatedSince = {
    _updated: {
      $gte: moment().subtract(1, 'days').toDate().toGMTString(),
    },
  };

  const getStatusFilter = () => {
    switch (opts.status) {
      case 'assigned': return { assigned: opts.assignedTo };
      case 'urgent': return { severity: 'critical', ...inStatus('open') };
      case 'closed': return { ...inStatus(opts.status), ...updatedSince };
      case 'all': return { $or: [inStatus('open_resolved'), { ...inStatus('closed_canceled'), ...updatedSince }] };
      default: return inStatus(opts.status);
    }
  };

  const channelFilter = opts.onlyMyChannels ? { channel: { $in: opts.channels } } : {};

  const query = whereQuery({
    affiliate_id: dedeshify(affiliateId),
    ...channelFilter,
    ...getStatusFilter(),
  }, {
    max_results: opts.max_results,
    sort: opts.sort,
  });

  return api(`/ticket/service_request?${query}`)
    .then(resp => resp.json());
};

export const getRequest = requestId =>
  api(`/ticket/service_request/${requestId}`)
    .then(resp => resp.json());

export const getServiceConfigs = (affiliateId, sort = '_created', maxResults = 500) =>
  api(`/ticket/service_config?${whereQuery({ affiliate_id: dedeshify(affiliateId) }, { sort, max_results: maxResults })}`)
    .then(returnItems);

export const getServiceConfigByName = (affiliateId, name) =>
  api(`/ticket/service_config?${whereQuery({ affiliate_id: dedeshify(affiliateId), service_name: name })}`)
    .then(returnItems)
    .then(_.first);

export const updateServiceRequest = (requestId, payload) =>
  api(`/ticket/service_request/${requestId}`, {
    ...applicationJsonType,
    method: 'PATCH',
    body: JSON.stringify(payload),
  }).then(resp => resp.json());



// WEBPACK FOOTER //
// ./src/api/ticket.js